// Returns the current time in the following format: yyyy-MM-dd HH:mm:ss z
// Example: 2021-12-10 15:53:23 -08:00
export default function getUTCTimeStamp() {
    const date = Date().split(' ')
    const monthList = {Jan:'01',Feb:'02',Mar:'03',Apr:'04',May:'05',Jun:'06',Jul:'07',Aug:'08',Sep:'09',Oct:'10',Nov:'11',Dec:'12'}
    const month = monthList[date[1]]
    const offset = `${date[5].slice(3).substring(0,3)}:${date[5].slice(3).substring(3)}`
    return `${date[3]}-${month}-${date[2]} ${date[4]} ${offset}`
}